const DynamicPostRequest = (() => {
    const DOM = {};
    let previousArchiveLoaded = '';
    let previousArchiveDate = '';
    let observerTarget;
    let targetClicked = false;

    const cacheDOM = () => {
        DOM.categoriesParent = document.getElementsByClassName("js-categories")[0];
        DOM.categories = document.querySelectorAll(".js-categories > li");
        DOM.loadMore   = document.getElementById("js-load-more");
        DOM.parentEl   = document.getElementsByClassName("js-categories-wrapper")[0];
        DOM.parentSection = document.getElementsByClassName("js-categories-section")[0];
        DOM.loadMoreBlogArchive = document.getElementsByClassName("js-load-blog-archive-post");
    }

    const removeLoader = () => {
        setTimeout(() => {
            if ( document.getElementsByClassName("loading")[0] ) document.getElementsByClassName("loading")[0].remove();
            if ( document.getElementsByClassName("loading")[0] ) DOM.loadMore.innerHTML = `Load More`;
            if ( document.getElementsByClassName("loading-circle")[0] ) document.getElementsByClassName("loading-circle")[0].remove();
            DOM.parentSection.classList.remove('js-loading');
        },500);
    }

    const updatePosts = (postData, postType) => {
        let content = '';

        if ( postType === 'post' ) {
            const postTitle = postData.title;
            const postDescription = postData.excerpt;
            const postThumbnail = postData.thumbnail;
            const postURL = postData.url;
            const postCategories = postData.taxonomy;
            const postPrimaryCategory = postData.primaryTaxonomy;
            const postDate = postData.date;

            let postCategory = '';

            if ( postPrimaryCategory ) {
                postCategory = `<li>${postPrimaryCategory}</li>`;
            } else {
                Array.from(postCategories).forEach( category => {
                    postCategory += `<li>${category}</li>`;
                 });
            }

            content = `<div class="content__post__item content__post__item--blog">
                            <div class="content__post__item__wrapper">
                                <a href="${postURL}">
                                    <div class="content__post__image content__post__image--alt">
                                        ${postThumbnail}
                                    </div>
                                    <div class="content__post__item__text">
                                        <ul>
                                            ${postCategory}
                                            <li>${postDate}</li>
                                        </ul>
                                        <h3>${postTitle}</h3>
                                    </div>
                                </a>
                            </div>
                        </div>`;

        } else if ( postType === 'team' ) {
            const postTitle = postData.title;
            const postThumbnail = postData.thumbnail;
            const postThumbnailAlt = postData.thumbnail_alt;
            const postJobTitle = postData.job_title ?
                                `<span>${postData.job_title}</span>`
                                : false;
            const postContactDetails = postData.contact_details;
            const postSocialDetails = postData.social_details;

            let contactDetails = '';
            if ( postContactDetails ) {
                contactDetails += `<ul>`;
                Array.from(postContactDetails).forEach( contact => {
                    const telephone_label = contact.telephone_label
                                            ? `<span>${contact.telephone_label} :</span>`
                                            : '';
                    const telephone_number = contact.telephone_number ?? '';
                    const telephone_add_extension = contact.telephone_add_extension ?? '';
                    const telephone_extension = contact.telephone_extension ?? '';
                    const telephone_ext_text = telephone_add_extension
                                            ? `<span>Ext : ${telephone_extension}</span>`
                                            : '';

                    contactDetails += `<li>
                                        ${telephone_label}
                                        <a href="tel:${telephone_number}" class="team__item__email button-arrow">
                                            ${telephone_number}
                                        </a>
                                       ${telephone_ext_text}
                                    </li>`;
                })
                contactDetails += `</ul>`;
            }

            let socialDetails = '';
            if ( postSocialDetails ) {
                socialDetails += `<div class="team__item__contacts team__item__contacts--column">
                                <ul class="team__item__social">`;
                Array.from(postSocialDetails).forEach( social => {
                    const social_label = social.social_label ?? '';
                    const social_url = social.social_url ?? '';

                    socialDetails += `<li class="${social_label}">
                                        <a href="${social_url}"
										   target="_blank"
										   rel="noopener noreferrer"
										   title="${social_label}">
											<span class="sr-only">${social_label}</span>
										</a>
                                    </li>`;
                })
                socialDetails += `</ul>
                                </div>`;
            }

            content = `<div class="team__item">
                            <img src="${postThumbnail}" alt="${postThumbnailAlt}">
                            <div class="team__item__inner">
                                <div class="team__item__details">
                                    <h3>
                                        ${postTitle}
                                    </h3>
                                    ${postJobTitle}
                                    ${contactDetails}
                                </div>
                                ${socialDetails}
                            </div>
                        </div>`;

        } else {
            const postTitle = postData.title;
            const postDescription = postData.excerpt;
            const postThumbnail = postData.thumbnail;
            const postURL = postData.url;
            const postCategories = postData.taxonomy;
            let postCategory = '';

            Array.from(postCategories).forEach( category => {
                postCategory += `<li>${category}</li>`;
             });

            content = `<div class="listing-grid__item">
                        <a href="${postURL}" title="${postTitle}">
                            <div class="listing-grid__image">
                                ${postThumbnail}
                            </div>
                        </a>
                        <div class="listing-grid__details">
                            <ul>
                                ${postCategory}
                            </ul>
                            <h3>
                                <a href="${postURL}">${postTitle}</a>
                            </h3>
                        </div>
                    </div>`;
        }

        return content;
    }

    const showAllPosts = (postsData, postType, nextPage, postID, postDateYear, postDateMonth ) => {

        if ( postType === 'team' ) {
            const categoryTitle = DOM.parentSection.querySelector('.team__heading > h2');
            const categoryDescription = DOM.parentSection.querySelector('.team__heading > p');
            categoryTitle.innerHTML = postsData.categoryTitle;
            categoryDescription.innerHTML = '';
        }

        if ( !nextPage || ( nextPage && postID === "" ) ) {
            const oldPosts = document.getElementsByClassName("listing-grid__item");
            Array.from(oldPosts).forEach( oldPost => {
                oldPost.remove();
            });
        }

        if ( nextPage ) {
            const { paged, max_num_pages } = postsData.pagination;
            const loadMoreBtn = document.getElementById("js-load-more");

            if(loadMoreBtn != null) {

                DOM.loadMore.style.display = "block";

                loadMoreBtn.setAttribute('data-load-next', `${nextPage++}`);
                loadMoreBtn.dataset.loadNext = `${nextPage++}`;
                paged >= max_num_pages
                    ? DOM.loadMore.style.display = "none"
                    : false;

                if (paged >= max_num_pages) lazyLoadObserver.unobserve(observerTarget);
            }
        }

        let content = '';
        postsData.postDetails.forEach((post) => {
            content += updatePosts(post, postType);
        });

        if ( postDateMonth || postDateYear ) {
            const { paged, max_num_pages } = postsData.pagination;
            const loadMoreBtn = document.getElementById("js-load-more");
            const currentArchiveLoaded = ( postDateMonth && postDateYear ) ? 'month' : 'year';
            const currentArchiveDateLoaded = postDateYear ?? false;
            const archiveLoadPage = loadMoreBtn.getAttribute( 'data-load-next' );

            nextPage = true;

            max_num_pages > "1"
                ? loadMoreBtn.style.display = "block"
                : loadMoreBtn.style.display = "none";

            if ( ( previousArchiveLoaded !== '' && previousArchiveLoaded !== currentArchiveLoaded )
                || ( previousArchiveDate !== currentArchiveDateLoaded )
                || archiveLoadPage === "2" ) {
                const oldBlogPosts = document.getElementsByClassName("content__post__item--blog");
                Array.from(oldBlogPosts).forEach( oldPost => {
                    oldPost.remove();
                });

                loadMoreBtn.setAttribute( 'data-load-next', "2" );
                loadMoreBtn.dataset.loadNext = "2";
            }

            if ( postDateMonth ) {
                loadMoreBtn.setAttribute( 'data-month', `${postDateMonth}` );
                loadMoreBtn.dataset.month = `${postDateMonth}`;
            } else {
                loadMoreBtn.removeAttribute( 'data-month' );
            }

            if ( postDateYear ) {
                loadMoreBtn.setAttribute( 'data-year', `${postDateYear}` );
                loadMoreBtn.dataset.year = `${postDateYear}`;
            } else {
                loadMoreBtn.removeAttribute( 'data-year' );
            }

            previousArchiveLoaded = currentArchiveLoaded;
            previousArchiveDate = currentArchiveDateLoaded;
        }

        if ( nextPage && DOM.loadMore != null ) {
            DOM.loadMore.insertAdjacentHTML('beforebegin', content);
        } else {
            console.log('here');
            if ( DOM.loadMore != null  && postType !== 'post' ) {
                console.log('here2');
                DOM.loadMore.insertAdjacentHTML('beforebegin', content);
            } else {
                DOM.parentEl.innerHTML = content;
            }
        }

        // if ( targetClicked ) {
        //     lazyLoadObserver.observe(document.getElementById("js-load-more"));
        // }

        if ( document.getElementById("js-load-more") ) {
            lazyLoadObserver.observe(document.getElementById("js-load-more"));
        }

        removeLoader();
    }

    const setFilterActive = (target) => {
        const element = target.currentTarget;
        element.classList.add('active');
    }

    const removeActiveState = () => {
        Array.from( DOM.categories ).forEach( ( category ) => {
            category.classList.remove('active');
        });
    }

    const getCategoryDetails = (el, elementClicked = false) => {
        if ( observerTarget  ) {
            lazyLoadObserver.unobserve(observerTarget);
        } else if ( document.getElementById("js-load-more") ) {
            lazyLoadObserver.unobserve(document.getElementById("js-load-more"));
        }

        if ( elementClicked ) {
            el.preventDefault();
            el.stopPropagation();

            removeActiveState();
            setFilterActive(el);


            targetClicked = true;
        }

        const targetElement = elementClicked ? el.currentTarget : el.target;

        const postPaged = targetElement.getAttribute('data-load-next') ?? false;
        const postPagedArgs = postPaged ? `&paged=${postPaged}` : '';

        const postPerPage = targetElement.getAttribute('data-post-per-page') ?? false;
        const postPerPageArgs = postPerPage ? `&posts_per_page=${postPerPage}` : '';

        const postDateYear = targetElement.getAttribute('data-year') ?? false;
        const postDateYearArgs = postDateYear ? `&year=${postDateYear}` : '';

        const postDateMonth = targetElement.getAttribute('data-month') ?? false;
        const postDateMonthArgs = postDateMonth ? `&month=${postDateMonth}` : '';

        const postTag = DOM.categoriesParent.getAttribute("data-post-tag");
        const postTagArgs = postTag ? `&post_tag=${postTag}` : '';

        const postCat = DOM.categoriesParent.getAttribute("data-post-cat");
        const postCatArgs = postCat ? `&post_cat=${postCat}` : '';

        const postType = DOM.categoriesParent.getAttribute("data-post-type");
        const postTypeArgs = postType ? `&post_type=${postType}` : '';

        const postID = targetElement.getAttribute('data-id');
        const selectedCategoryID = postID;
        const categoryPostsDataURL = ( postID === "" || postID === null )
            ? `${document.location.origin}/wp-json/v2/taxonomy/all?${postTagArgs}${postCatArgs}${postTypeArgs}${postPagedArgs}${postPerPageArgs}${postDateYearArgs}${postDateMonthArgs}`
            : `${document.location.origin}/wp-json/v2/taxonomy?${postTypeArgs}&taxonomy_id=${selectedCategoryID}`;

        if ( elementClicked ) {
            const loader = `<div class="loading-circle"><div class="loading-circle__eclipse"><div></div></div></div>`;
            DOM.parentSection.insertAdjacentHTML('beforeend', loader);
        } else {
            const loader = `<div class="loading"><div></div><div></div><div></div><div></div></div>`;
            DOM.loadMore.innerHTML = loader;
        }

        DOM.parentSection.classList.add('js-loading');

        const postsRequest = new XMLHttpRequest();
        postsRequest.open("GET", categoryPostsDataURL);
        postsRequest.send();
        postsRequest.onload = () => {
            if (postsRequest.status === 200) {
                const postsData = JSON.parse(postsRequest.response);
                if (postID === "" || postID === null) {
                    showAllPosts(postsData, postType, postPaged, postID, postDateYear, postDateMonth);
                } else {
                    showAllPosts(postsData, postType);
                }
            }
        };
    }

    const lazyLoadObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                getCategoryDetails(entry);
                observerTarget = entry.target;
            }
        });
    });


    const eventListener = () => {
        if (DOM.categories) {
            Array.from( DOM.categories ).forEach( ( category ) => {
                category.addEventListener("click", (event) => getCategoryDetails(event, true));
            });
        }
        if (DOM.loadMore) {
            lazyLoadObserver.observe(document.getElementById("js-load-more"));
            // DOM.loadMore.addEventListener("click", getCategoryDetails);
        }
        if (DOM.loadMoreBlogArchive) {
            Array.from( DOM.loadMoreBlogArchive ).forEach( ( button ) => {
                button.addEventListener("click", (event) => getCategoryDetails(event, true));
            });
        }
    }

    const init = () => {
        cacheDOM();
        eventListener();
    }

    return {
        init
    }

})();

export default DynamicPostRequest;
